import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SendAlert() {
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "send-alert-in-archive-modal",
    type: "info",
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(InfoIcon, {
        color: "do-not-use-calypso",
        size: "300"
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        marginInlineStart: "200",
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.emailArchive.sendAlert.title"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.emailArchive.sendAlert.description"
        })]
      })]
    })
  });
}